import script from "./NotebookPageEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./NotebookPageEditor.vue?vue&type=script&setup=true&lang=js"

import "./NotebookPageEditor.vue?vue&type=style&index=0&id=609f1290&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609f1290"]])

export default __exports__